module.exports = __webpack_public_path__ + "img/portrait-048.c84df95a.jpg";